"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityExtraFieldValue = getEntityExtraFieldValue;
var types_1 = require("../types");
var verifyType_1 = require("./verifyType");
function getEntityExtraFieldValue(field, value, resolveToFriendlyValue) {
    if (resolveToFriendlyValue === void 0) { resolveToFriendlyValue = false; }
    try {
        var newValue = (0, verifyType_1.verifyType)(field, value);
        if (resolveToFriendlyValue) {
            return resolveFieldValueToFriendlyValue(field, newValue);
        }
        return newValue;
    }
    catch (_a) {
        if (field.schema.default !== undefined) {
            var newValue = (0, verifyType_1.verifyType)(field, field.schema.default);
            if (resolveToFriendlyValue) {
                return resolveFieldValueToFriendlyValue(field, newValue);
            }
            return newValue;
        }
        else if (!field.schema.required) {
            return null;
        }
        else {
            throw new Error("Invalid value for field ".concat(field.name));
        }
    }
}
function resolveFieldValueToFriendlyValue(field, value) {
    var _a, _b, _c, _d;
    if (field.schema.type === 'enum') {
        if (!Array.isArray(field.schema.properties))
            throw new Error();
        if (typeof value !== 'number')
            throw new Error();
        return ((_b = (_a = field.schema.properties[value].ui) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : field.schema.properties[value].name);
    }
    if (field.schema.type === 'boolean') {
        var booleanMeta = types_1.BooleanFieldMetaSchema.parse(field.schema.meta);
        var trueLabel = (_c = booleanMeta['blackframe.boolean']) === null || _c === void 0 ? void 0 : _c.trueLabel;
        var falseLabel = (_d = booleanMeta['blackframe.boolean']) === null || _d === void 0 ? void 0 : _d.falseLabel;
        if (value === true) {
            return trueLabel || 'True';
        }
        else if (value === false) {
            return falseLabel || 'False';
        }
        else {
            throw new Error();
        }
    }
    return value;
}
